import React from 'react';
import { OptimizeSEO } from '../../components/OptimizeSEO';
import { ISEOData } from '../../constants/SEOConstant';

interface IProps {
    seoData: ISEOData;
    sections: React.ReactNode;
}

export const GuidesPage: React.FC<IProps> = (props: IProps) => {
    const { seoData, sections } = props;
    return (<>
        <div className="mx-auto text-gray-900 dark:text-white">
            <OptimizeSEO {...seoData}/>
            <article className="space-y-12">{sections}</article>
        </div>
    </>
    );
};

